/**
 * Converting a task list to the single-editor format leaves its child `TASK` elements behind, as stragglers.
 * Nothing renders or reads them, so a copy of the list must leave them out.
 * The server rejects a `TASK` created under a converted list, which fails the whole paste.
 */

// Utils
import { isTask } from '../elements/utils/elementTypeUtils';
import { getLocationParentId } from '../elements/utils/elementPropertyUtils';
import { getElement } from '../elements/utils/elementTraversalUtils';
import { isSingleEditorTaskList } from './taskListContentVersionUtils';

// Types
import type { ImMNElement, ImMNElementMap, MNElement, MNElementMap } from '../elements/elementModelTypes';

type ElementMap = MNElementMap | ImMNElementMap;
type Element = MNElement | ImMNElement | undefined;

/**
 * Checks whether an element is a `TASK` left behind under a converted task list, either directly
 * or as a sub-task of one. A task under a legacy list is a real task.
 */
export const isConvertedTaskListStraggler = (elementMap: ElementMap, element: Element): boolean => {
    if (!element || !isTask(element)) return false;

    const parent = getElement(elementMap, getLocationParentId(element));
    if (!parent) return false;
    if (isSingleEditorTaskList(parent)) return true;

    return isConvertedTaskListStraggler(elementMap, parent);
};
